import {Navigate, Outlet, useLocation, matchPath} from 'react-router-dom'
import {IS_REDIRECT_ENABLED, ROUTES} from '../helpers/constants'
import {useUserStore} from '../features/user/store'

export const PublicRoute = () => {
    const accessToken = useUserStore(store => store.accessToken)
    const adminAccessToken = useUserStore(store => store.adminAccessToken)
    const location = useLocation()
    const isAdminLogin = matchPath({path: ROUTES.ADMIN_LOGIN}, location.pathname)
    if (adminAccessToken && isAdminLogin) {
        return <Navigate to={ROUTES.ADMIN} />
    }

    if (IS_REDIRECT_ENABLED) {
        return <Outlet />
    }

    return accessToken ? <Navigate to={ROUTES.INDEX} /> : <Outlet />
}
